 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCH_COVER from '@/components/Text/CH_cover'
 import TEXTCH_ENDORSE from '@/components/Text/CH_endorse'
 import TEXTCH_LANGHAM from '@/components/Text/CH_langham'
 import TEXTCH_TITLEPAGE from '@/components/Text/CH_titlepage'
 import TEXTCH_IMPRINT from '@/components/Text/CH_imprint'
 import TEXTCH_CONTENTS from '@/components/Text/CH_contents'
 import TEXTCH_AUTHORS from '@/components/Text/CH_authors'
 import TEXTCH_PREFACE from '@/components/Text/CH_preface'
 import TEXTCH_NOTETOREADER from '@/components/Text/CH_notetoreader'
 import TEXTCH_SERIESINTRO from '@/components/Text/CH_seriesintro'
 import TEXTCH_INTRO from '@/components/Text/CH_intro'
 import TEXTCH_CH01 from '@/components/Text/CH_ch01'
 import TEXTCH_CH02 from '@/components/Text/CH_ch02'
 import TEXTCH_CH03 from '@/components/Text/CH_ch03'
 import TEXTCH_CH04 from '@/components/Text/CH_ch04'
 import TEXTCH_CONC from '@/components/Text/CH_conc'
 import TEXTCH_NOTES from '@/components/Text/CH_notes'
 import TEXTCH_ADVERT from '@/components/Text/CH_advert'
 import TEXTCH_LANGHAM2 from '@/components/Text/CH_langham2'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/CH_contents",
 			"name" : "Text/CH_contents",
 			"component" : TEXTCH_CONTENTS
 		},
 		{
 			"path" : "/Text/CH_authors",
 			"name" : "Text/CH_authors",
 			"component" : TEXTCH_AUTHORS
 		},
 		{
 			"path" : "/Text/CH_preface",
 			"name" : "Text/CH_preface",
 			"component" : TEXTCH_PREFACE
 		},
 		{
 			"path" : "/Text/CH_notetoreader",
 			"name" : "Text/CH_notetoreader",
 			"component" : TEXTCH_NOTETOREADER
 		},
 		{
 			"path" : "/Text/CH_seriesintro",
 			"name" : "Text/CH_seriesintro",
 			"component" : TEXTCH_SERIESINTRO
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js